import { createTwStyle, joinCn } from '../util';
import { DIALOG_CONTAINER_POSITION } from './constant';
import type { VDialogProps } from './type';

const TW_POSITION_STYLE_MAPPER = {
  [DIALOG_CONTAINER_POSITION.TOP_LEFT]: 'justify-start items-start',
  [DIALOG_CONTAINER_POSITION.TOP]: 'justify-center items-start',
  [DIALOG_CONTAINER_POSITION.TOP_RIGHT]: 'justify-end items-start',
  [DIALOG_CONTAINER_POSITION.LEFT]: 'justify-start items-center',
  [DIALOG_CONTAINER_POSITION.CENTER]: 'justify-center items-center',
  [DIALOG_CONTAINER_POSITION.RIGHT]: 'justify-end items-center',
  [DIALOG_CONTAINER_POSITION.BOTTOM_LEFT]: 'justify-start items-end',
  [DIALOG_CONTAINER_POSITION.BOTTOM]: 'justify-center items-end',
  [DIALOG_CONTAINER_POSITION.BOTTOM_RIGHT]: 'justify-end items-end',
};

const twStyle = createTwStyle<VDialogProps>();

export default twStyle({
  vDialog: joinCn('absolute h-0 w-0'),
  vDialogBackDrop: ({ whiteBackdrop = false }) =>
    joinCn(
      'fixed top-0 left-0',
      'flex items-center justify-center',
      'h-screen w-screen',
      whiteBackdrop ? 'bg-white/50' : 'bg-black/50',
    ),
  vDialogContainer: ({ position = 'center', disabledBackdrop = false }) =>
    joinCn(
      'fixed top-0 left-0',
      'flex items-center justify-center',
      'h-screen w-screen',
      'p-2.5',
      'outline-none',
      position && TW_POSITION_STYLE_MAPPER[position],
      {
        'pointer-events-none': disabledBackdrop,
        'pointer-events-auto': !disabledBackdrop,
      },
    ),
  vDialogMain: joinCn(
    'pointer-events-auto relative rounded-md bg-gray-300',
    'overflow-hidden shadow-md shadow-v-dialog-shadow',
  ),
});
